import React from 'react';

function Privacy() {
  return (
    <p>
      <br />
      Protecting your private information is our priority. This Statement of
      Privacy applies to rebuildblackbusiness.com and Rebuild Black Business and
      governs data collection and usage. For the purposes of this Privacy
      Policy, unless otherwise noted, all references to Rebuild Black Business
      include rebuildblackbusiness.com and RBB. The RBB website is a Non-Profit
      site. By using the RBB website, you consent to the data practices
      described in this statement.
      <br />
      <br />
      <strong>Collection of your Personal Information</strong>
      <br />
      <br /> In order to better provide you with products and services offered
      on our Site, RBB may collect personally identifiable information, such as
      your:
      <br />
      <br />
      - First and Last Name
      <br />
      - E-mail Address
      <br />
      <br />
      Please keep in mind that if you directly disclose personally identifiable
      information or personally sensitive data through RBB's public message
      boards, this information may be collected and used by others.
      <br />
      <br />
      We do not collect any personal information about you unless you
      voluntarily provide it to us. However, you may be required to provide
      certain personal information to us when you elect to use certain products
      or services available on the Site. These may include: (a) registering for
      an account on our Site; (b) entering a sweepstakes or contest sponsored by
      us or one of our partners; (c) signing up for special offers from selected
      third parties; (d) sending us an email message; (e) submitting your credit
      card or other payment information when ordering and purchasing products
      and services on our Site. To wit, we will use your information for, but
      not limited to, communicating with you in relation to services and/or
      products you have requested from us. We also may gather additional
      personal or non-personal information in the future.
      <br />
      <br />
      <strong>Use of your Personal Information</strong>
      <br />
      <br />
      RBB collects and uses your personal information to operate its website(s)
      and deliver the services you have requested.
      <br />
      <br />
      RBB may also use your personally identifiable information to inform you of
      other products or services available from RBB and its affiliates.
      <br />
      <br />
      <strong>Sharing Information with Third Parties</strong>
      <br />
      <br />
      RBB does not sell, rent or lease its customer lists to third parties.
      <br />
      <br />
      RBB may, from time to time, contact you on behalf of external business
      partners about a particular offering that may be of interest to you. In
      those cases, your unique personally identifiable information (e-mail,
      name, address, telephone number) is not transferred to the third party.
      RBB may share data with trusted partners to help perform statistical
      analysis, send you email or postal mail, provide customer support, or
      arrange for deliveries. All such third parties are prohibited from using
      your personal information except to provide these services to RBB, and
      they are required to maintain the confidentiality of your information.
      <br />
      <br />
      RBB may disclose your personal information, without notice, if required to
      do so by law or in the good faith belief that such action is necessary to:
      (a) conform to the edicts of the law or comply with legal process served
      on RBB or the site; (b) protect and defend the rights or property of RBB;
      and/or (c) act under exigent circumstances to protect the personal safety
      of users of RBB, or the public.
      <br />
      <br />
      <strong>Tracking User Behavior</strong>
      <br />
      <br />
      RBB may keep track of the websites and pages our users visit within RBB,
      in order to determine what RBB services are the most popular. This data is
      used to deliver customized content and advertising within RBB to customers
      whose behavior indicates that they are interested in a particular subject
      area.
      <br />
      <br />
      <strong>Automatically Collected Information</strong>
      <br />
      <br />
      Information about your computer hardware and software may be automatically
      collected by RBB. This information can include: your IP address, browser
      type, domain names, access times and referring website addresses. This
      information is used for the operation of the service, to maintain quality
      of the service, and to provide general statistics regarding use of the RBB
      website.
      <br />
      <br />
      <strong>Links</strong>
      <br />
      <br />
      This website contains links to other sites. Please be aware that we are
      not responsible for the content or privacy practices of such other sites.
      We encourage our users to be aware when they leave our site and to read
      the privacy statements of any other site that collects personally
      identifiable information.
      <br />
      <br />
      <strong>Security of your Personal Information</strong>
      <br />
      <br />
      RBB secures your personal information from unauthorized access, use, or
      disclosure. RBB uses the following methods for this purpose:
      <br />
      <br />
      - SSL Protocol
      <br />
      <br />
      When personal information (such as a credit card number) is transmitted to
      other websites, it is protected through the use of encryption, such as the
      Secure Sockets Layer (SSL) protocol.
      <br />
      <br />
      We strive to take appropriate security measures to protect against
      unauthorized access to or alteration of your personal information.
      Unfortunately, no data transmission over the Internet or any wireless
      network can be guaranteed to be 100% secure. As a result, while we strive
      to protect your personal information, you acknowledge that: (a) there are
      security and privacy limitations inherent to the Internet which are beyond
      our control; and (b) security, integrity, and privacy of any and all
      information and data exchanged between you and us through this Site cannot
      be guaranteed.
      <br />
      <br />
      <strong>Right to Deletion</strong>
      <br />
      <br />
      Subject to certain exceptions set out below, on receipt of a verifiable
      request from you, we will:
      <br />
      <br />
      • Delete your personal information from our records; and
      <br />
      • Direct any service providers to delete your personal information from
      their records.
      <br />
      <br />
      Please note that we may not be able to comply with requests to delete your
      personal information if it is necessary to:
      <br />
      • Complete the transaction for which the personal information was
      collected, fulfill the terms of a written warranty or product recall
      conducted in accordance with federal law, provide a good or service
      requested by you, or reasonably anticipated within the context of our
      ongoing business relationship with you, or otherwise perform a contract
      between you and us;
      <br />
      • Detect security incidents, protect against malicious, deceptive,
      fraudulent, or illegal activity; or prosecute those responsible for that
      activity;
      <br />
      • Debug to identify and repair errors that impair existing intended
      functionality;
      <br />
      • Exercise free speech, ensure the right of another consumer to exercise
      his or her right of free speech, or exercise another right provided for by
      law;
      <br />
      • Comply with the California Electronic Communications Privacy Act;
      <br />
      • Engage in public or peer-reviewed scientific, historical, or statistical
      research in the public interest that adheres to all other applicable
      ethics and privacy laws, when our deletion of the information is likely to
      render impossible or seriously impair the achievement of such research,
      provided we have obtained your informed consent;
      <br />
      • Enable solely internal uses that are reasonably aligned with your
      expectations based on your relationship with us;
      <br />
      • Comply with an existing legal obligation; or
      <br />
      • Otherwise use your personal information, internally, in a lawful manner
      that is compatible with the context in which you provided the information.
      <br />
      <br />
      <strong>Children Under Thirteen</strong>
      <br />
      <br />
      RBB does not knowingly collect personally identifiable information from
      children under the age of thirteen. If you are under the age of thirteen,
      you must ask your parent or guardian for permission to use this website.
      <br />
      <br />
      <strong>Disconnecting your RBB Account from Third Party Websites</strong>
      <br />
      <br />
      You will be able to connect your RBB account to third party accounts. BY
      CONNECTING YOUR RBB ACCOUNT TO YOUR THIRD PARTY ACCOUNT, YOU ACKNOWLEDGE
      AND AGREE THAT YOU ARE CONSENTING TO THE CONTINUOUS RELEASE OF INFORMATION
      ABOUT YOU TO OTHERS (IN ACCORDANCE WITH YOUR PRIVACY SETTINGS ON THOSE
      THIRD PARTY SITES). IF YOU DO NOT WANT INFORMATION ABOUT YOU, INCLUDING
      PERSONALLY IDENTIFYING INFORMATION, TO BE SHARED IN THIS MANNER, DO NOT
      USE THIS FEATURE. You may disconnect your account from a third party
      account at any time. Users can discponnecy access to their accounts on
      third-party sites by submitting request for this information to be removed
      from the rebuildblackbusiness.com site.
      <br />
      <br />
      <strong>E-mail Communications</strong>
      <br />
      From time to time, RBB may contact you via email for the purpose of
      providing announcements, promotional offers, alerts, confirmations,
      surveys, and/or other general communication. In order to improve our
      Services, we may receive a notification when you open an email from RBB or
      click on a link therein.
      <br />
      <br />
      If you would like to stop receiving marketing or promotional
      communications via email from RBB, you may opt out of such communications
      by clicking the unsubscribe link within the email..
      <br />
      <br />
      <strong>Changes to this Statement</strong>
      <br />
      <br />
      RBB reserves the right to change this Privacy Policy from time to time. We
      will notify you about significant changes in the way we treat personal
      information by sending a notice to the primary email address specified in
      your account, by placing a prominent notice on our site, and/or by
      updating any privacy information on this page. Your continued use of the
      Site and/or Services available through this Site after such modifications
      will constitute your: (a) acknowledgment of the modified Privacy Policy;
      and (b) agreement to abide and be bound by that Policy.
      <br />
      <br />
      <strong>Contact Information</strong>
      <br />
      <br />
      RBB welcomes your questions or comments regarding this Statement of
      Privacy. If you believe that RBB has not adhered to this Statement, please
      contact RBB at:
      <br />
      <br />
      Rebuild Black Business
      <br />
      P.O. Box 13881
      <br />
      Atlanta, Georgia 30324
      <br />
      <br />
      Email Address: social@rebuildblackbusiness.com
      <br /> _________________
      <br />
      Effective as of June 10, 2020
      <br />
    </p>
  );
}

export default Privacy;
